import { FETCH_GOOGLE_PLACES } from '../actions/types';

export default function googlePlacesReducer(state = null, action) {
	switch (action.type) {
		case FETCH_GOOGLE_PLACES:
			return action.payload || false;
		default:
			return state;
	}
}
